import React from 'react';
import placeholderImage from '../images/lababt.png'; // Laboratory image

const Intro = () => {
    /* Previous version kept for easy revert.
    return (
        <div className="relative flex items-center justify-center m-auto max-w-7xl px-4 md:px-6 pt-4 md:pt-6 pb-2" id="about">
            <div className="flex flex-col pt-6 pb-2 justify-center items-center text-center" data-aos="fade-up">
                <div className="w-full mb-6">
                    <h3 className="text-4xl font-extrabold text-maroon leading-tight tracking-tight">
                        About Texcellence Specialties Private Limited
                    </h3>
                </div>
                <div className="flex flex-col lg:flex-row justify-between items-center w-full max-w-6xl space-y-6 lg:space-y-0 lg:space-x-8">
                    <div className="lg:w-2/5 flex justify-center mb-4 lg:mb-0">
                        <div className="relative overflow-hidden rounded-xl shadow-lg transform transition duration-500 hover:scale-105 hover:shadow-2xl">
                            <img alt="Texcellence Specialties" className="w-full h-auto object-cover" src={placeholderImage} />
                        </div>
                    </div>
                    <div className="lg:w-3/5 px-2 lg:px-4">
                        <p className="text-lg text-gray-700 font-normal mb-6 leading-relaxed text-justify">Established in 2014 in Dombivli, Thane district, Maharashtra, India, Texcellence Specialties Private Limited is a leading manufacturer of specialty chemicals for the textile industry. ...</p>
                        <p className="text-lg text-gray-700 font-normal leading-relaxed text-justify">Our state-of-the-art production facilities ...</p>
                        <p className="text-sm text-gray-600 font-medium mt-4"><span className="text-[#5b2a2a]">Certified:</span> ISO 9001:2015 • ISO 14001:2015 • ISO 45001:2018 • GMP</p>
                    </div>
                </div>
            </div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-gradient-to-r from-maroon to-red-500 rounded-full opacity-40 blur-3xl -translate-x-1/3 translate-y-1/3"></div>
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-r from-maroon to-yellow-500 rounded-full opacity-40 blur-3xl translate-x-1/3 -translate-y-1/3"></div>
        </div>
    );
    */
    return (
        <section id="about" className="bg-white">
            <div className="max-w-[1600px] mx-auto px-6 lg:px-16 py-16 md:py-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-aos="fade-up">

                    {/* Image — left column on desktop */}
                    <div className="lg:col-span-5">
                        <div className="relative">
                            <div className="absolute -inset-3 bg-[#5b2a2a]/5 rounded-2xl -z-10" aria-hidden="true"></div>
                            <img
                                alt="Texcellence Specialties"
                                src={placeholderImage}
                                className="w-full h-auto object-cover rounded-2xl shadow-[0_20px_60px_rgba(91,42,42,0.12)]"
                            />
                        </div>
                    </div>

                    {/* Copy — right column */}
                    <div className="lg:col-span-7">
                        <div className="text-sm font-bold tracking-[0.22em] uppercase text-[#5b2a2a] mb-5 flex items-center gap-3">
                            <span className="w-10 h-[2px] bg-[#5b2a2a]"></span>
                            About Us
                        </div>

                        <h2 className="text-3xl md:text-4xl lg:text-[2.6rem] font-bold text-[#1f2937] tracking-tight leading-[1.15] mb-5">
                            Specialty chemistry, <span className="text-[#5b2a2a]">made for textiles.</span>
                        </h2>

                        <p className="text-base md:text-lg text-[#4b5563] leading-relaxed mb-4 max-w-2xl">
                            Established in 2014 in Dombivli, Maharashtra, Texcellence Specialties Private Limited is a leading manufacturer of specialty chemicals for the textile industry — adding value at every stage, from fiber to fabric to garment.
                        </p>

                        <p className="text-base md:text-lg text-[#4b5563] leading-relaxed mb-8 max-w-2xl">
                            Our state-of-the-art facilities in Dombivli MIDC and Khed MIDC, Chiplun are run by a team of skilled technologists, chemists, and engineers who deliver customized products and technical solutions for every customer need.
                        </p>

                        {/* Inline stat row */}
                        <div className="grid grid-cols-3 gap-4 sm:gap-8 max-w-xl border-t border-[#f0e6e6] pt-6 mb-8">
                            <div>
                                <div className="text-2xl md:text-3xl font-bold text-[#5b2a2a] leading-none">2014</div>
                                <div className="text-xs text-[#6b7280] mt-1.5 uppercase tracking-wider">Established</div>
                            </div>
                            <div>
                                <div className="text-2xl md:text-3xl font-bold text-[#5b2a2a] leading-none">100%</div>
                                <div className="text-xs text-[#6b7280] mt-1.5 uppercase tracking-wider">Biodegradable</div>
                            </div>
                            <div>
                                <div className="text-2xl md:text-3xl font-bold text-[#5b2a2a] leading-none">2</div>
                                <div className="text-xs text-[#6b7280] mt-1.5 uppercase tracking-wider">Facilities</div>
                            </div>
                        </div>

                        {/* Certification badges */}
                        <div className="flex flex-wrap items-center gap-2">
                            {['ISO 9001:2015', 'ISO 14001:2015', 'ISO 45001:2018', 'GMP'].map((cert) => (
                                <span
                                    key={cert}
                                    className="inline-flex items-center px-3 py-1 text-xs font-semibold text-[#5b2a2a] bg-[#5b2a2a]/5 border border-[#5b2a2a]/15 rounded-full"
                                >
                                    {cert}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Intro;
